module.exports = __webpack_public_path__ + "static/media/spinner.dd999754.svg";